<div class="my-message__container">
  <p class="my-message__paragraph" [innerHtml]="messageText | formatTextWithLinks"></p>
</div>
